<template>
    <div id="wrap">
        <!-- header -->
        <div id="header">
            <div class="container">
                <div class="logo">
                    <a><i /><span class="blind">FMS</span></a>
                </div>
                <div class="header-nav">
                    <ul>
                        <li>
                            <a class="logout" @click="logout"><i /><span class="blind">로그아웃</span></a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <!-- // header -->

        <!-- content-wrap -->
        <main id="content-wrap">
            <div id="contents">
                <!-- user-info -->
                <div class="user-info">
                    <p v-if="constructionNm != 'null'" class="location">
                        {{ constructionNm }}
                    </p>
                    <p class="nm">
                        {{ name }}
                    </p>
                </div>
                <!-- // user-info -->

                <!-- quick-link -->
                <div class="quick-link">
                    <ul>
                        <li>
                            <a class="btn-register" @click="write">
                                <i /><span>페이스매핑<br />신규 작성</span>
                            </a>
                        </li>
                        <li>
                            <a class="btn-list" @click="list">
                                <i /><span>페이스매핑<br />목록 보기</span>
                            </a>
                        </li>
                    </ul>
                </div>
                <!-- // quick-link -->

                <!-- fms-list -->
                <div class="fms-list-box">
                    <div class="list-header">
                        <h2>페이스매핑 최신목록</h2>
                        <a class="view-more" @click="list"><i /><span class="blind">더보기</span></a>
                    </div>

                    <ul>
                        <li
                            v-for="(data, index) in datas"
                            :key="index"
                            @click="detail(data.tunnelConstructionMethod, data.constructionCode, data.id)"
                        >
                            <a>
                                <span v-if="data.threeDimensionalImageUrl" class="thumb">
                                    <img :src="data.threeDimensionalImageUrl" :alt="data.threeDimensionalImageUrl" />
                                </span>
                                <span v-else class="thumb">
                                    <span v-if="data.tunnelConstructionMethod === '017002'">
                                        <img
                                            v-if="data.tbmLeftImageUrl"
                                            :src="data.tbmLeftImageUrl"
                                            :alt="data.tbmLeftImageUrl"
                                        />
                                    </span>
                                    <span v-else>
                                        <img
                                            v-if="data.frontImageUrl"
                                            :src="data.frontImageUrl"
                                            :alt="data.frontImageUrl"
                                        />
                                    </span>
                                </span>
                                <span>{{ data.station }}</span>
                                <span style="color: #c0c3c8;">{{ data.tunnelConstructionMethodName }}</span>
                            </a>
                        </li>
                    </ul>
                </div>
                <!-- // fms-list -->
            </div>
        </main>
        <!-- // content-wrap -->
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import FacemappingApi from '../api/FacemappingApi';
import LoginApi from '../api/LoginApi';
import { CONSTRUCTION, CONSTRUCTION_NM, NAME, TYPE } from '../const';

export default {
    name: 'Main',
    components: {},
    data: () => {
        return {
            datas: [],
            name: '',
            constructionNm: ''
        };
    },
    computed: {
        ...mapState({})
    },
    beforeCreate() {
        ///////////////////////
        // Initializer Area
        ///////////////////////
        //this.showLoading();
        //this.$store.dispatch('showLoading');
    },
    created() {},
    mounted() {
        this.name = localStorage.getItem(NAME);
        this.constructionNm = localStorage.getItem(CONSTRUCTION_NM);

        this.showLoading();
        FacemappingApi.list({
            page: 1,
            rows: 6,
            sort: 'investigationDay desc,reg_dt',
            direction: 'desc'
        }).then(res => {
            this.datas = res.content;
            console.log('res.content:::', res.content);
            this.hideLoading();
        });
    },
    beforeDestroy() {},
    methods: {
        ...mapActions(['showLoading', 'hideLoading']),
        async logout() {
            const res = await LoginApi.logout();
            localStorage.removeItem(CONSTRUCTION_NM);
            localStorage.removeItem(CONSTRUCTION);
            localStorage.removeItem(NAME);
            localStorage.removeItem(TYPE);
            this.$router.push({
                name: 'Login'
            });
        },
        write() {
            this.$router.push({
                name: 'Step1'
            });
        },
        list() {
            this.$router.push({
                name: 'List'
            });
        },
        detail(tunnelConstructionMethod, constructionCode, id) {
            if (tunnelConstructionMethod == '017001') this.$router.push({ path: `/detail/${constructionCode}/${id}` });
            else this.$router.push({ path: `/detailTBM/${constructionCode}/${id}` });
        }
    }
};
/*
#wrap > div {
    height: inherit;
}
*/
</script>
